import { createFileRoute } from "@tanstack/react-router";

import { FlowOperation } from "~/components/feature/flow/components";

export const Route = createFileRoute("/_app/dashboard/flow/operation")({
  component: RouteComponent,
});

function RouteComponent() {
  return <FlowOperation />;
}
